function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import IconWrapper from '../../lib/IconWrapper';
import useFormHelpers from '../../hooks/useFormHelpers';

const TextInput = ({
  icon,
  value,
  ...props
}) => React.createElement(IconWrapper, {
  icon: icon
}, React.createElement(TextField, _extends({
  fullWidth: true,
  inputProps: {
    'aria-label': props.label
  },
  value: typeof value === 'string' && value.length > 0 ? value.replace(new RegExp('<br />', 'g'), '\n') : value
}, props)));

TextInput.propTypes = {
  icon: PropTypes.element,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'email', 'number'])
};

const LinkedTextInput = props => {
  const {
    value,
    ...helpers
  } = useFormHelpers(props, {
    getValue: event => props.type === 'number' && event.target.value ? parseFloat(event.target.value) : event.target.value
  });
  return React.createElement(TextInput, _extends({
    value: value || ''
  }, helpers));
};

LinkedTextInput.propTypes = {
  name: PropTypes.string.isRequired
};
export { TextInput, LinkedTextInput };